(function () {
  'use strict';
  function cartUpdateUrl() {
    return window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update.js';
  }
  function mergeNote() {
    var cfgEl = document.querySelector('.js-cart-note-vat-config');
    if (!cfgEl) return;
    var cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent || '{}');
    } catch (e) {
      return;
    }
    var lines = cfg.lines;
    if (!lines || !lines.length) return;

    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var note = String(cart.note || '');
        var next = note;
        for (var i = 0; i < lines.length; i++) {
          var line = String(lines[i] || '').trim();
          if (!line) continue;
          if (next.indexOf(line) === -1) {
            next = next ? next + '\n' + line : line;
          }
        }
        if (next === note) return;
        var codes = (cart.discount_codes || [])
          .map(function (d) {
            return typeof d === 'string' ? d : d && d.code;
          })
          .filter(Boolean)
          .join(',');
        var payload = { note: next };
        if (codes) payload.discount = codes;
        return fetch(cartUpdateUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mergeNote);
  } else {
    mergeNote();
  }
})();
